import values from 'lodash/values';
import isEmpty from 'lodash/isEmpty';
import flatten from 'lodash/flatten';
import ListingType, { CommercialListingTypeKeys, ResidentialListingTypeKeys } from './listing-type';
import PropertyTypeCategory from './property-type-category';
var NON_DEVELOPMENT_RESIDENTIAL = [ListingType.SALES_RESIDENTIAL.name, ListingType.RENTAL_RESIDENTIAL.name, ListingType.SHARE_RESIDENTIAL.name];
export var PropertyTypeKeys = ['HOUSE', 'TOWNHOUSE', 'COTTAGE', 'UNIT', 'LAND', 'RURAL', 'APARTMENT', 'DUPLEX', 'COMMERCIAL_STUDIO', 'RELOCATABLE_HOME', 'VILLA', 'OTHER', 'INVESTMENT_PROPERTY', 'HOUSE_AND_LAND_PACKAGE', 'DUAL_OCCUPANCY', 'RETIREMENT_VILLAGE', 'CHALET', 'TRI_OCCUPANCY', 'COURTYARD_HOME', 'OFFICE', 'RETAIL', 'INDUSTRIAL', 'HOTEL', 'MOTEL', 'WAREHOUSE', 'OTHER_COMMERCIAL', 'COMMERCIAL_LAND', 'BUSINESS', 'RESIDENTIAL_WAREHOUSE', 'DEVELOPMENT', 'PROPERTY', 'UNKNOWN', 'OTHER'];
var PropertyTypeValues = {
  HOUSE: {
    index: 1,
    name: 'HOUSE',
    label: 'House',
    pluralLabel: 'Houses',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: [],
    urlSlug: 'house',
    metaDescription: 'a house',
    category: PropertyTypeCategory.HOUSE
  },
  TOWNHOUSE: {
    index: 2,
    name: 'TOWNHOUSE',
    label: 'Townhouse',
    pluralLabel: 'Townhouses',
    listingTypes: ResidentialListingTypeKeys,
    equivalents: [],
    urlSlug: 'townhouse',
    metaDescription: 'a townhouse',
    category: PropertyTypeCategory.TOWNHOUSE
  },
  COTTAGE: {
    index: 3,
    name: 'COTTAGE',
    label: 'Cottage',
    pluralLabel: 'Cottages',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['HOUSE'],
    metaDescription: 'a cottage',
    category: PropertyTypeCategory.HOUSE
  },
  UNIT: {
    index: 4,
    name: 'UNIT',
    label: 'Unit / Apartment',
    pluralLabel: 'Units / Apartments',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: [],
    urlSlug: 'unit-apartment',
    metaDescription: 'a unit / apartment',
    category: PropertyTypeCategory.UNIT
  },
  LAND: {
    index: 5,
    name: 'LAND',
    label: 'Land',
    pluralLabel: 'Land',
    listingTypes: [ListingType.SALES_RESIDENTIAL.name, ListingType.DEVELOPMENTS_RESIDENTIAL.name],
    equivalents: [],
    urlSlug: 'land',
    metaDescription: 'land',
    category: PropertyTypeCategory.OTHER
  },
  RURAL: {
    index: 6,
    name: 'RURAL',
    label: 'Rural',
    pluralLabel: 'Rural',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: [],
    urlSlug: 'rural',
    metaDescription: 'a rural property',
    category: PropertyTypeCategory.OTHER
  },
  APARTMENT: {
    index: 7,
    name: 'APARTMENT',
    label: 'Apartment',
    pluralLabel: 'Apartments',
    listingTypes: ResidentialListingTypeKeys,
    equivalents: ['UNIT'],
    metaDescription: 'an apartment',
    category: PropertyTypeCategory.UNIT
  },
  DUPLEX: {
    index: 8,
    name: 'DUPLEX',
    label: 'Duplex',
    pluralLabel: 'Duplex',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: [],
    urlSlug: 'duplex',
    metaDescription: 'a duplex',
    category: PropertyTypeCategory.HOUSE
  },
  COMMERCIAL_STUDIO: {
    index: 9,
    name: 'COMMERCIAL_STUDIO',
    label: 'Studio',
    pluralLabel: 'Studios',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: [],
    urlSlug: 'studio',
    metaDescription: 'a studio',
    category: PropertyTypeCategory.OTHER
  },
  RELOCATABLE_HOME: {
    index: 10,
    name: 'RELOCATABLE_HOME',
    label: 'Relocatable Home',
    pluralLabel: 'Relocatable Homes',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['OTHER'],
    metaDescription: 'a relocatable home',
    category: PropertyTypeCategory.OTHER
  },
  VILLA: {
    index: 11,
    name: 'VILLA',
    label: 'Villa',
    pluralLabel: 'Villa',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['HOUSE'],
    metaDescription: 'a villa',
    category: PropertyTypeCategory.HOUSE
  },
  OTHER: {
    index: 12,
    name: 'OTHER',
    label: 'Other',
    pluralLabel: 'Other',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: [],
    urlSlug: 'other',
    metaDescription: 'a property',
    category: PropertyTypeCategory.OTHER
  },
  INVESTMENT_PROPERTY: {
    index: 13,
    name: 'INVESTMENT_PROPERTY',
    label: 'Investment Property',
    pluralLabel: 'Investment Properties',
    listingTypes: [ListingType.SALES_RESIDENTIAL.name],
    equivalents: [],
    urlSlug: 'investment-property',
    metaDescription: 'an investment property',
    category: PropertyTypeCategory.OTHER
  },
  HOUSE_AND_LAND_PACKAGE: {
    index: 14,
    name: 'HOUSE_AND_LAND_PACKAGE',
    label: 'House and Land Package',
    pluralLabel: 'House and Land Packages',
    listingTypes: [ListingType.SALES_RESIDENTIAL.name, ListingType.DEVELOPMENTS_RESIDENTIAL.name],
    equivalents: [],
    urlSlug: 'house-land',
    metaDescription: 'a house and land package',
    category: PropertyTypeCategory.OTHER
  },
  DUAL_OCCUPANCY: {
    index: 15,
    name: 'DUAL_OCCUPANCY',
    label: 'Dual Occupancy',
    pluralLabel: 'Dual Occupancy',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['TOWNHOUSE', 'DUPLEX'],
    metaDescription: 'a dual occupancy',
    category: PropertyTypeCategory.OTHER
  },
  RETIREMENT_VILLAGE: {
    index: 16,
    name: 'RETIREMENT_VILLAGE',
    label: 'Retirement Village',
    pluralLabel: 'Retirement Village',
    listingTypes: [ListingType.SALES_RESIDENTIAL.name],
    equivalents: [],
    urlSlug: 'retirement-village',
    metaDescription: 'a retirement village property',
    category: PropertyTypeCategory.OTHER
  },
  CHALET: {
    index: 17,
    name: 'CHALET',
    label: 'Chalet',
    pluralLabel: 'Chalet',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['HOUSE'],
    metaDescription: 'a chalet',
    category: PropertyTypeCategory.HOUSE
  },
  TRI_OCCUPANCY: {
    index: 18,
    name: 'TRI_OCCUPANCY',
    label: 'Tri Occupancy',
    pluralLabel: 'Tri Occupancy',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['TOWNHOUSE', 'DUPLEX'],
    metaDescription: 'a tri occupancy',
    category: PropertyTypeCategory.OTHER
  },
  COURTYARD_HOME: {
    index: 19,
    name: 'COURTYARD_HOME',
    label: 'Courtyard Home',
    pluralLabel: 'Courtyard Home',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['TOWNHOUSE'],
    metaDescription: 'a courtyard home',
    category: PropertyTypeCategory.TOWNHOUSE
  },
  OFFICE: {
    index: 20,
    name: 'OFFICE',
    label: 'Office',
    pluralLabel: 'Offices',
    icon: 'office',
    listingTypes: CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'office',
    metaDescription: 'an office property',
    category: PropertyTypeCategory.OTHER
  },
  RETAIL: {
    index: 21,
    name: 'RETAIL',
    label: 'Retail',
    pluralLabel: 'Retail',
    listingTypes: CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'retail',
    metaDescription: 'a retail property',
    category: PropertyTypeCategory.OTHER
  },
  INDUSTRIAL: {
    index: 22,
    name: 'INDUSTRIAL',
    label: 'Industrial',
    pluralLabel: 'Industrial',
    listingTypes: CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'industrial',
    metaDescription: 'an industrial property',
    category: PropertyTypeCategory.OTHER
  },
  HOTEL: {
    index: 23,
    name: 'HOTEL',
    label: 'Hotel',
    pluralLabel: 'Hotels',
    listingTypes: CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'hotel',
    metaDescription: 'a hotel property',
    category: PropertyTypeCategory.OTHER
  },
  MOTEL: {
    index: 24,
    name: 'MOTEL',
    label: 'Motel',
    pluralLabel: 'Motels',
    listingTypes: CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'motel',
    metaDescription: 'a motel property',
    category: PropertyTypeCategory.OTHER
  },
  WAREHOUSE: {
    index: 25,
    name: 'WAREHOUSE',
    label: 'Warehouse',
    pluralLabel: 'Warehouses',
    listingTypes: CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'warehouse',
    metaDescription: 'a warehouse property',
    category: PropertyTypeCategory.OTHER
  },
  OTHER_COMMERCIAL: {
    index: 26,
    name: 'OTHER_COMMERCIAL',
    label: 'Other Commercial',
    pluralLabel: 'Other Commercial',
    listingTypes: CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'other-commercial',
    metaDescription: 'a commercial property',
    category: PropertyTypeCategory.OTHER
  },
  COMMERCIAL_LAND: {
    index: 27,
    name: 'COMMERCIAL_LAND',
    label: 'Commercial Land',
    pluralLabel: 'Commercial Land',
    listingTypes: CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'commercial-land',
    metaDescription: 'a commercial property',
    category: PropertyTypeCategory.OTHER
  },
  BUSINESS: {
    index: 28,
    name: 'BUSINESS',
    label: 'Business',
    pluralLabel: 'Businesses',
    listingTypes: CommercialListingTypeKeys,
    equivalents: [],
    urlSlug: 'business',
    metaDescription: 'a commercial property',
    category: PropertyTypeCategory.OTHER
  },
  RESIDENTIAL_WAREHOUSE: {
    index: 29,
    name: 'RESIDENTIAL_WAREHOUSE',
    label: 'Residential Warehouse',
    pluralLabel: 'Residential Warehouses',
    listingTypes: ResidentialListingTypeKeys,
    equivalents: ['OTHER'],
    metaDescription: 'a residential warehouse',
    category: PropertyTypeCategory.OTHER
  },
  DEVELOPMENT: {
    index: 30,
    name: 'DEVELOPMENT',
    label: 'Apartment / Off the plan',
    pluralLabel: 'Apartments / Off the plan',
    listingTypes: [ListingType.DEVELOPMENTS_RESIDENTIAL.name],
    equivalents: [],
    alias: 'UNIT',
    urlSlug: 'development',
    metaDescription: 'an apartment / off the plan property',
    category: PropertyTypeCategory.OTHER
  },
  PROPERTY: {
    index: 31,
    name: 'PROPERTY',
    label: 'Property',
    pluralLabel: 'Properties',
    listingTypes: [ListingType.OFF_MARKET.name],
    equivalents: [],
    urlSlug: '',
    metaDescription: 'a property',
    category: PropertyTypeCategory.OTHER
  },
  UNKNOWN: {
    index: 32,
    name: 'UNKNOWN',
    label: 'Other',
    pluralLabel: 'Other',
    listingTypes: NON_DEVELOPMENT_RESIDENTIAL,
    equivalents: ['OTHER'],
    metaDescription: 'a property',
    category: PropertyTypeCategory.OTHER
  }
};
var PropertyType = PropertyTypeValues;
export var propertyTypesWhere = function propertyTypesWhere() {
  var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => true;
  return values(PropertyType).filter(predicate);
};
export var getEquivalentPropertyTypes = typeName => propertyTypesWhere(propertyType => propertyType.name === typeName || propertyType.equivalents.includes(typeName));
export var propertyTypeByIndex = index => values(PropertyType).find(propertyType => propertyType.index === index);
export var getPrimaryPropertyTypesForListingType = listingTypeName => propertyTypesWhere(propertyType => isEmpty(propertyType.equivalents) && propertyType.listingTypes.includes(listingTypeName));
var resolveAlias = propertyType => {
  var _PropertyType$propert, _PropertyType$propert2;
  return (_PropertyType$propert = (_PropertyType$propert2 = PropertyType[propertyType]) === null || _PropertyType$propert2 === void 0 ? void 0 : _PropertyType$propert2.alias) !== null && _PropertyType$propert !== void 0 ? _PropertyType$propert : propertyType;
};
export var expandPropertyTypes = requestedTypes => flatten(requestedTypes.map(requestedType => resolveAlias(requestedType)).map(requestedType => values(PropertyType).filter(type => type.name === requestedType || (type.equivalents || []).includes(requestedType)).map(type => type.name)));
export var propertyTypeReducer = requestedTypes => propertyType => expandPropertyTypes([propertyType]).find(typeName => requestedTypes.includes(typeName)) || 'OTHER';
export default PropertyType;